import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Y from '../../../y18n'

import PageNamesDropdown from '../../../common/dropdowns/page-names-dropdown'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import LanguagesDropdown from '../../../common/dropdowns/languages-dropdown'
import * as pageTextActions from '../../../store/page-texts'
import SimpleMDE from 'react-simplemde-editor'
import Styles from '../../../common/styles'
import 'simplemde/dist/simplemde.min.css'

const mapStateToProps = state => ({
  pageTexts: state.pageTexts
})

const mapDispatchToProps = dispatch => ({
  pageTextActions: bindActionCreators(pageTextActions, dispatch)
})

class EditPageTextDialog extends Component {
  inputChanged = name => e => {
    this.props.pageTextActions.updateActive(name, e.target.value)
  }

  handleContentChange = value => {
    this.props.pageTextActions.updateActive('content', value)
  }

  submitForm (e, pageText) {
    e.preventDefault()
    this.props.pageTextActions.editPageText(pageText)
  }

  render () {
    const { classes, pageTexts, pageTextActions } = this.props
    if (!pageTexts.active || pageTexts.new) return null
    return (
      <div>
        <Dialog
          open={pageTexts.active && pageTexts.active !== null}
          onClose={() => pageTextActions.resetActive()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitForm(e, pageTexts.active)}>
            <DialogTitle>{Y`Edit page text`}</DialogTitle>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Title`}
                type='text'
                value={pageTexts.active.title}
                onChange={this.inputChanged('title')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                helperText={Y`This title will only appear in the list of pagetexts`}
                fullWidth
              />
              <div className={classes.flexRow}>
                <div className={classes.flexItemLeft}>
                  <PageNamesDropdown handleChange={this.inputChanged('pageName')} value={pageTexts.active.pageName} />
                </div>
                <div className={classes.flexItemMiddle}>
                  <CountriesDropdown handleChange={this.inputChanged('country')} value={pageTexts.active.country} />
                </div>
                <div className={classes.flexItemRight}>
                  <LanguagesDropdown handleChange={this.inputChanged('language')} value={pageTexts.active.language} />
                </div>
              </div>
            </DialogContent>
            <DialogContent>
              <SimpleMDE
                onChange={this.handleContentChange}
                value={pageTexts.active.content}
                options={{ spellChecker: false }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => pageTextActions.resetActive()}>{Y`Cancel`}</Button>
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

EditPageTextDialog = connect(mapStateToProps, mapDispatchToProps)(EditPageTextDialog)
export default withStyles(Styles)(EditPageTextDialog)



// WEBPACK FOOTER //
// ./src/pages/page-texts/containers/edit-page-text-dialog.js